import { createDefaultText } from './text';
import type { BookmarkEndElement, BookmarkStartElement } from '../types';

export function createBookmarkStart(markerId: number, name: string): BookmarkStartElement {
  return {
    children: [createDefaultText()],
    markerId,
    name,
    suggestedEdits: [],
    type: 'bookmarkStart',
  };
}

export function createBookmarkEnd(markerId: number): BookmarkEndElement {
  return {
    children: [createDefaultText()],
    markerId,
    suggestedEdits: [],
    type: 'bookmarkEnd',
  };
}

/**
 * Word-style internal bookmarks (e.g. `_Ref…`, `_Toc…`, `_Hlk…`, `_top`) have
 * names starting with an underscore. They are auto-created for cross references,
 * tables of contents, and hyperlinks, and are hidden from the user
 */
export function isHiddenBookmarkName(name: string): boolean {
  return name.startsWith('_');
}
